module.exports = __webpack_public_path__ + "img/5.07a65dff.jpg";